module.exports = __webpack_public_path__ + "img/112.2.067c99a8.png";